<template>
  <div id="content" v-show="!loading">
    <service-settings-popup
        v-if="servicePopupData"
        :popup-data="servicePopupData"
        :non-linear-options="nonLinearOptions"
        @save-settings="saveServiceSettings"
        @close-popup="servicePopupData = null"
    ></service-settings-popup>
    <content-source-content-popup
        v-if="contentSourceContentPopupData"
        :popup-data="contentSourceContentPopupData"
        :id-channel="this.entity.id"
        :non-linear-options="nonLinearOptions"
        @save-settings="saveContentSourceContentData"
        @close-popup="onCloseContentSourceContentPopup"
        ref="contentsourcecontentpopupref"
    />
    <form>
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-if="entity.name">{{ entity.name }}</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <detail-entity-info
                  :entity="entity"
              >
                <template v-slot:pre-data>
                  <p class="profile_image_box">
                  <label class="profile_image logo"><img :src="entity.logo_url"></label>
                </p>
                </template>
              </detail-entity-info>
              <p><translate>ID EPG</translate>: <span>{{ entity.id_epg }}</span></p>
              <p v-if="entity.type != 'radio'"><translate>Kvalita obrazu</translate>: <span>{{ entity.video_quality }}</span></p>
              <p><translate>Kódy jazyků</translate>: <span>{{ entity.language_code }}</span></p>
              <p><translate>Typ EPG</translate>: <span>{{ entity.epg_type }}</span></p>
              <p v-if="entity.last_import && entity.last_import.broadcasts_count"><translate>Počet naimportovaných broadcastů</translate>: <span>{{ entity.last_import.broadcasts_count }}</span></p>
              <p v-if="entity.last_import && entity.last_import.timestamp"><translate>Čas posledního importu</translate>: <span class="date" v-html="$_date_formatFull(entity.last_import.timestamp)"></span></p>
            </div>

            <div class="right">

              <div class="field_left">
                  <text-input id="channelname"
                              :required="true"
                              v-model="entity.name"
                              :disabled="!isEditable"
                              ref="nameref"
                              :help-text="$gettext('výchozí')+': '+entity.default_name"
                  >
                    <translate class="translate">Název kanálu</translate>
                    <a
                        v-if="entity.default_name != entity.name"
                        class="reset_btn"
                        :title="$gettext('Nastavit výchozí hodnotu')"
                        @click.stop.prevent="entity.name = entity.default_name"
                    >Resetovat</a>
                  </text-input>
              </div>
              <div class="field_right">
                <text-input id="channelnameweight"
                            :required="true"
                            v-model="entity.weight"
                            :disabled="!isEditable"
                            ref="weightref"
                            :help-text="$gettext('výchozí')+': '+entity.default_weight"
                >
                  <translate class="translate">Váha</translate>
                  <a
                      v-if="entity.default_weight != entity.weight"
                      class="reset_btn"
                      :title="$gettext('Nastavit výchozí hodnotu')"
                      @click.stop.prevent="entity.weight = entity.default_weight"
                  >Resetovat</a>
                </text-input>
              </div>
              <div class="field_left">
                <text-input
                    id="channelidremote"
                    v-model="entity.id_remote"
                    :disabled="!isEditable"
                    ref="idremoteref"
                    :help-text="entity.default_id_remote ? $gettext('výchozí')+': '+entity.default_id_remote : ''"
                >
                  <a
                      v-if="showDefaultRemoteId"
                      class="reset_btn"
                      :title="$gettext('Nastavit výchozí hodnotu')"
                      @click.stop.prevent="entity.id_remote = entity.default_id_remote"
                  >Resetovat</a>
                  <translate class="translate">Vlastní ID</translate>
                </text-input>
              </div>
              <div class="field_right">
                <select-box
                    id="channelusedrm"
                    v-model="entity.use_drm"
                    :options="useDrmOptions"
                    :disabled="!isEditable"
                    :help-text="useDrmHelpText"
                    ref="usedrmref"
                >
                  <translate class="translate">Použít DRM</translate>
                </select-box>
              </div>
              <div class="field_left">
                  <checkbox-input
                      id="channellock"
                      v-model="entity.lock"
                      :disabled="!isEditable"
                      :help-text="lockChannelNamesText"
                      ref="lockref"
                  >
                    <translate class="translate">Zamknout kanál</translate>
                  </checkbox-input>
                <checkbox-input
                    id="channelstartliveastimeshift"
                    v-model="entity.start_live_as_timeshift"
                    :disabled="true"
                    ref="channelstartliveastimeshiftref"
                >
                  <translate class="translate">Přehrávat při živém přehrávání timeshift playlist</translate>
                </checkbox-input>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <h2 v-translate>Navázání kanálu</h2>
            </div>
            <div class="right">
              <multiselect-searchbox
                  v-if="entity.id_services !== null"
                  :disabled="!isEditable"
                  :searchFunction="searchServices"
                  v-model="entity.id_services"
                  :hide-multi-selection="true"
                  :hide-remove-all="true"
                  :non-editable-ids="nonEditableServices"
                  :operators-only="!$_updateActionAllowedAllOrOwnAndGlobal"
                  :click-callback-function="serviceSettingsCallback"
              ><translate>Navázat na službu</translate>
                <template v-slot:settings>
                  <a class="settings" v-translate>Nastavení</a>
                </template>
              </multiselect-searchbox>
              <multiselect-searchbox
                  v-if="entity.id_packages !== null"
                  :disabled="!isEditable"
                  :searchFunction="searchPackages"
                  v-model="entity.id_packages"
                  :hide-multi-selection="true"
                  :hide-remove-all="true"
                  :non-editable-ids="nonEditableChannelPackages"
                  :operators-only="!$_updateActionAllowedAllOrOwnAndGlobal"
              ><translate>Navázat na balíček</translate></multiselect-searchbox>
              <multiselect-searchbox
                  v-if="entity.id_content_sources !== null"
                  :disabled="!isEditable"
                  :searchFunction="searchContentSources"
                  v-model="entity.id_content_sources"
                  :hide-multi-selection="true"
                  :hide-remove-all="true"
                  :non-editable-ids="nonEditableContentSources"
                  :click-callback-function="contentSourceSettingsCallback"
                  :on-add-callback-function="newContentSourceSettingsCallback"
              ><translate>Navázat na zdroj obsahu</translate>
                <template v-slot:settings>
                  <a class="settings" v-translate>Nastavení</a>
                </template>
              </multiselect-searchbox>
            </div>
          </section>
          <detail-bottom-buttons
              v-if="isEditable"
              section-class="buttons"
              :show-link="true"
              :module-name="moduleName"
              @submit-form="submitForm"
          ></detail-bottom-buttons>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import DetailEntityInfo from "../../common/DetailEntityInfo";
import channels from "./mixins/channels";
import ServiceSettingsPopup from "@/components/common/ServiceSettingsPopup"
import ContentSourceContentPopup from "./ContentSourceContentPopup.vue";

export default {
  name: "channelDetail",
  components: {DetailEntityInfo, ServiceSettingsPopup, ContentSourceContentPopup},
  mixins: [detailActions, channels],
  created(ChannelService, ServiceService, PackageService, ContentSourceService) {
    this.entityService = ChannelService;
    this.serviceService = ServiceService;
    this.packageService = PackageService;
    this.contentSourceService = ContentSourceService;
    this.createdInit();
  },
  data() {
    return {
      moduleName: 'channels',
      entityName: 'channel',
      servicePopupData: null,
      contentSourceContentPopupData: null,
      serviceSettingsId: null,
      contentSourceContentId: null,
      contentSourceIsNew: false,
    }
  },
  computed:{
    isEditable(){
      return this.$_loggedUser_action_allowed('channels', 'update', ['OWN', 'OWN_AND_GLOBAL', 'GLOBAL', 'ALL']);
    },
    showDefaultRemoteId(){
      return this.entity.default_id_remote && this.entity.default_id_remote !== this.entity.id_remote;
    },
    nonEditableServices(){
      return this.$_updateActionAllowedAllOrOwnAndGlobal ? [] : this.entity.global_services_ids;
    },
    nonEditableChannelPackages(){
      return this.$_updateActionAllowedAllOrOwnAndGlobal ? [] : this.entity.global_packages_ids;
    },
    nonEditableContentSources(){
      return this.$_updateActionAllowedAllOrOwnAndGlobal ? [] : this.entity.global_content_sources_ids;
    },
    searchMethodsOperator(){
      let role = this.$store.getters.getUserRoleList[this.$route.meta.sectionName]['read']
      return role === "ALL" ? null : this.$_loggedUser_selectedOperatorId;
    },
    lockChannelNamesText(){
      if(this.entity.lock_channel_names){
        return this.$gettext('Vztahuje se na kanály')+ ': '+this.entity.lock_channel_names;
      }else{
        return '';
      }
    },
    useDrmOptions(){
      return [
        {id: 'never', text: this.$gettext('Nikdy')},
        {id: 'preferred', text: this.$gettext('Preferováno')},
        {id: 'required', text: this.$gettext('Vyžadováno')},
      ]
    },
    useDrmHelpText(){
      if(this.entity.default_use_drm){
        let text = '';
        switch (this.entity.default_use_drm){
          case ('never'):
            text = this.$gettext('Nikdy');
            break;
          case ('preferred'):
            text = this.$gettext('Preferováno');
            break;
          case ('required'):
            text = this.$gettext('Vyžadováno');
            break;
          default:
              text = this.$gettext('Neznámé');
        }

        return this.$gettext('výchozí') + ': ' + text;
      }else{
        return '';
      }
    }
  },
  methods: {
    searchPackages(search, selectAll=false, init = false, operatorOnly = false, filterIds = []) {
      return this.packageService.searchPackagesByNameOrId({search: search, selected_operator: this.searchMethodsOperator, select_all: selectAll, operator_only: operatorOnly, filter_ids: filterIds});
    },
    searchServices(search, selectAll=false, init=false, operatorOnly = false, filterIds = []) {
      return this.serviceService.searchServicesByNameOrId({search: search, id_selected_operator: this.searchMethodsOperator, select_all: selectAll, operator_only: operatorOnly, filter_ids: filterIds});
    },
    searchContentSources(search, selectAll=false, init = false, operatorOnly = false, filterIds = []) {
      let params = {
        search: search,
        selected_operator: this.searchMethodsOperator,
        select_all: selectAll,
        init: init,
        filter_ids: filterIds
      };
      if(selectAll){
        params.id_channel = this.entity.id;
      }
      return this.contentSourceService.searchContentSourcesByNameOrId(params);
    },
    serviceSettingsCallback(id){
      this.serviceSettingsId = id;
      if(this.entity.services_nonlinear_settings.hasOwnProperty(id)){
        this.servicePopupData = this.entity.services_nonlinear_settings[id];
      }else{
        this.servicePopupData = {
          'catchup': null,
          'catchup_hours': null,
          'timeshift': null,
          'pvr': null,
          'periodic_pvr': null,
        }
      }
    },
    contentSourceSettingsCallback(id){
      this.contentSourceContentId = id;
      if(this.entity.hasOwnProperty('content_source_settings') && this.entity.content_source_settings.hasOwnProperty(id)){
        this.contentSourceContentPopupData = this.entity.content_source_settings[id];
      }else{
        this.contentSourceContentPopupData = {};
      }
      this.$nextTick(() => {
        this.$refs["contentsourcecontentpopupref"].init(id);
      });
    },
    newContentSourceSettingsCallback(id){
      this.contentSourceIsNew = true;
      this.contentSourceSettingsCallback(id);
    },
    saveServiceSettings(data){
      if(!this.entity.hasOwnProperty('changed_services_nonlinear_settings')){
        this.entity.changed_services_nonlinear_settings = [];
      }
      this.entity.services_nonlinear_settings[this.serviceSettingsId] = data;
      this.entity.changed_services_nonlinear_settings.push(this.serviceSettingsId);
      this.servicePopupData = null;
    },
    saveContentSourceContentData(data){
      if(!this.entity.hasOwnProperty('content_source_settings')){
        this.entity.content_source_settings = {};
      }
      this.entity.content_source_settings[this.contentSourceContentId] = data;
      this.contentSourceContentPopupData = null;
      this.contentSourceIsNew = false;
    },
    onCloseContentSourceContentPopup(){
      this.contentSourceContentPopupData = null;
      if(this.contentSourceIsNew){
        const index = this.entity.id_content_sources.indexOf(this.contentSourceContentId);
        this.entity.id_content_sources.splice(index,1);
      }
      this.contentSourceIsNew = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/channels/ChannelDetail.vue